import { toUnix } from './fmt_utils'

function getToken(key = 'jwt-token') {
    return localStorage.getItem(key)
}

function setToken(token, key = 'jwt-token') {
    return isJwt(token) && localStorage.setItem(key, token)
}

function removeToken(key = 'jwt-token') {
    return localStorage.removeItem(key)
}

function useTmpToken() {
    const token = localStorage.getItem('tmp-token')
    localStorage.removeItem('tmp-token')
    return token
}

function getPayload(token) {
    if (!isJwt(token)) return {}
    let payload
    try {
        payload = JSON.parse(atob(token.split('.')[1]))
    } catch (e) {
        return {}
    }
    return payload
}

function getTokenPayload(key = 'jwt-token') {
    const token = getToken(key)
    return getPayload(token)
}

function getExp(key = 'jwt-token') {
    const token = getToken(key)
    const exp = isJwt(token) ? getPayload(token).exp : 0
    const currentTime = toUnix(Date.now())
    return exp - currentTime // returns time remaining til token expires
}

function getEmail(key = 'jwt-token') {
    const token = getToken(key)
    return token ? getPayload(token).subject : ""
}

function isExpired(key = 'jwt-token') {
    const timeRemaining = getExp(key)
    return timeRemaining <= 0
}

function isLoggedIn(key = 'jwt-token') {
    return !isExpired(key)
}

function isJwt(token) {
    if (!token) return false
    if (typeof token !== 'string') return false
    const tokenArr = token.split('.')
    if (tokenArr.length !== 3) return false

    let headerStr = ''

    try {
        headerStr = atob(tokenArr[0])
    } catch (e) {
        return false
    }

    if (!headerStr) return false
    let header
    try {
        header = JSON.parse(headerStr)
    } catch (e) {
        return false
    }
    return header.typ === 'JWT'
}

export {
    getToken,
    setToken,
    removeToken,
    useTmpToken,
    getExp,
    getEmail,
    getPayload,
    getTokenPayload,
    isExpired,
    isLoggedIn,
    isJwt,
}



// WEBPACK FOOTER //
// ./src/util/jwt_utils.js